// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const SEARCH_FIELDS_PRIORITY = ['Basic']
const DATABASE_PAGE_SIZE = 10
const DATABASE_LOAD_ALL_COUNT = 1000

class Facet {
   applied: any
   enabled: any
   label: any
   name: any
   negated: any
   selected: any
   sorted: any
   values: any
   constructor(name: any, label: any, enabled: any) {
      this.name = name
      this.label = label
      this.enabled = enabled
      this.applied = 0
      this.negated = 0
      this.selected = 0
      this.sorted = "value"
      this.values = []
   }
}

class FacetDetails {
   active: any
   applied: any
   days: any
   disabled: any
   facetType: any
   negated: any
   orderBy: any
   translation: any
   value: any
   constructor(facetType: any, value: any, translation: any) {
      this.facetType = facetType
      this.value = value
      this.translation = translation
      this.applied = false
      this.negated = false
      this.active = false
      this.disabled = false
      this.days = null
      this.orderBy = 'translation';

      ({
         orderBy() {
            return this.orderBy
         }
      })
   }
}

class AdvancedSearchService {
   $booleanValues: any
   $broadcastTypes: any
   $facetTypes: any
   $filter: any
   $identifierFields: any
   $minLengthForBeginsWithQueries: any
   $rootScope: any
   alerts: any
   api: any
   appState: any
   datepickerService: any
   defaultScope: any
   eBooksFacet: any
   events: any
   fire: any
   i18n: any
   localeSort: any
   printBooksFacet: any
   scope: any
   utilities: any
   searchScopeService: SearchScopeService
   on: any
   viewState: ViewStateService
   constructor($rootScope: any, appState: AppStateService, utilities: UtilitiesService, $filter: any, events: EventService, datepickerService: DatepickerService, api: ApiService, alerts: AlertService, i18n: TranslationService, dataService: any, config: ConfigService, $booleanValues: any, $identifierFields: any, $minLengthForBeginsWithQueries: any, hooksService: HooksService, $broadcastTypes: any, $facetTypes: any, searchScopeService: SearchScopeService, viewState: ViewStateService) {
      this.markLoadedFacetGroupAsLoaded = this.markLoadedFacetGroupAsLoaded.bind(this)
      this.getFacetChecklist = this.getFacetChecklist.bind(this)
      this.getContentTypes = this.getContentTypes.bind(this)
      this.getDisciplines = this.getDisciplines.bind(this)
      this.getLanguages = this.getLanguages.bind(this)
      this.getLibraryLocations = this.getLibraryLocations.bind(this)
      this.getDatabases = this.getDatabases.bind(this)
      this.loadMoreDatabases = this.loadMoreDatabases.bind(this)
      this.loadAllDatabases = this.loadAllDatabases.bind(this)
      this.isDatabaseBlockVisible = this.isDatabaseBlockVisible.bind(this)
      this.sortFacetType = this.sortFacetType.bind(this)
      this.getOrAddCustomSearchField = this.getOrAddCustomSearchField.bind(this)
      this.addCustomField = this.addCustomField.bind(this)
      this.removeCustomField = this.removeCustomField.bind(this)
      this.removeFacets = this.removeFacets.bind(this)
      this.clear = this.clear.bind(this)
      this.buildSearchFieldsQuery = this.buildSearchFieldsQuery.bind(this)
      this.removeFacetFromSelectedSummary = this.removeFacetFromSelectedSummary.bind(this)
      this.findFacet = this.findFacet.bind(this)
      this.findAndUpdateFacetAppliedOrNegated = this.findAndUpdateFacetAppliedOrNegated.bind(this)
      this.checkAnyType = this.checkAnyType.bind(this)
      this.selectionsOnChange = this.selectionsOnChange.bind(this)
      this.excludeOtherNewRecords = this.excludeOtherNewRecords.bind(this)
      this.handlePhysicalAndEbook = this.handlePhysicalAndEbook.bind(this)
      this.updateFacetsInfo = this.updateFacetsInfo.bind(this)
      this.getSelectedAsString = this.getSelectedAsString.bind(this)
      this.getFacetLabel = this.getFacetLabel.bind(this)
      this.includeMatchesInFullTextOverrideIsAlwaysDisabled = this.includeMatchesInFullTextOverrideIsAlwaysDisabled.bind(this)
      this.addFacetToSummaryIfAppliedOrNegated = this.addFacetToSummaryIfAppliedOrNegated.bind(this)
      this.syncWithState = this.syncWithState.bind(this)
      this.belongsToAnEnabledFacet = this.belongsToAnEnabledFacet.bind(this)
      this.setRefinePaneFacets = this.setRefinePaneFacets.bind(this)
      this.convertConfigListToRefinePane = this.convertConfigListToRefinePane.bind(this)
      this.parseTermForQueryModifier = this.parseTermForQueryModifier.bind(this)
      this.determineQueryModifier = this.determineQueryModifier.bind(this)
      this.determineMinLength = this.determineMinLength.bind(this)
      this.isBalancedWhere = this.isBalancedWhere.bind(this)
      this.isBalanced = this.isBalanced.bind(this)
      this.cleanParenthesesBalanced = this.cleanParenthesesBalanced.bind(this)
      this.countBalanced = this.countBalanced.bind(this)
      this.splitQueryOnBoolean = this.splitQueryOnBoolean.bind(this)
      this.unescapeParentheses = this.unescapeParentheses.bind(this)
      this.parseQueryToAdvancedQueryValues = this.parseQueryToAdvancedQueryValues.bind(this)
      this.parseQueryToAdvancedQuery = this.parseQueryToAdvancedQuery.bind(this)
      this.addNewRecordsFacet = this.addNewRecordsFacet.bind(this)
      this.setNewRecordsFacets = this.setNewRecordsFacets.bind(this)
      this.addOrRemoveDateFromSelectedSummary = this.addOrRemoveDateFromSelectedSummary.bind(this)
      this.createDateRangeValue = this.createDateRangeValue.bind(this)
      this.setDateSelection = this.setDateSelection.bind(this)
      this.toggleOrExcludeValue = this.toggleOrExcludeValue.bind(this)
      this.submit = this.submit.bind(this)
      this.facetHasItsOwnParam = this.facetHasItsOwnParam.bind(this)
      this.hasMaxCustomRows = this.hasMaxCustomRows.bind(this)
      this.isAbsentFacetApplied = this.isAbsentFacetApplied.bind(this)
      this.isFacetApplied = this.isFacetApplied.bind(this)
      this.isFacetNegated = this.isFacetNegated.bind(this)
      this.refinePaneFacetApplied = this.refinePaneFacetApplied.bind(this)
      this.updateSearchScope = this.updateSearchScope.bind(this)
      this.$rootScope = $rootScope
      this.appState = appState
      this.utilities = utilities
      this.$filter = $filter
      this.events = events
      this.searchScopeService = searchScopeService
      this.datepickerService = datepickerService
      this.api = api
      this.alerts = alerts
      this.i18n = i18n
      this.$booleanValues = $booleanValues
      this.$identifierFields = $identifierFields
      this.$minLengthForBeginsWithQueries = $minLengthForBeginsWithQueries
      this.$broadcastTypes = $broadcastTypes
      this.$facetTypes = $facetTypes
      this.viewState = viewState
      this.defaultScope = {
         searchFields: config.data.advancedSearch.customSearchRows,
         searchFieldsConfig: config.data.advancedSearch.customSearchFields,
         scopeBuilderSearchFields: config.data.advancedSearch.scopeBuilderSearchRows,
         scopeBuilderSearchFieldsConfig: config.data.advancedSearch.scopeBuilderSearchFields,
         searchFieldsFromSecField: config.data.advancedSearch.customSearchRows.slice(1),
         config: config.data.advancedSearch,
         facetsConfig: config.data.facets,
         hasSearchScopes: config.data.search.hasSearchScopes,
         selectedSummary: [],

         includeFullTextMatchesDefault: config.data.toolbar.includeMatchesFullTextDefault,
         includeFullTextMatchesOverrideNonAdvanced: config.data.toolbar.includeMatchesFullTextOverride,
         hasSearched: false,
         // grab from settings in future maybe?
         datePresets: this.datepickerService.datepicker.datePresets,
         datePresetLabels: this.datepickerService.datepicker.datePresetLabels,
         dateSelection: this.datepickerService.datepicker.search,
         moreSearchOptionsShown: true,
         searchScope: this.searchScopeService.currentSearchScope?.label || '',
         searchScopeTerms: this.appState.searchScopeParams?.q || ""
      }

      this.scope = angular.copy(this.defaultScope)
      this.scope.advFacetsEnabled = config.data.advancedSearch.facets.enabled
      this.scope.advFacets = config.data.advancedSearch.facets

      // add facets for checkbox lists
      this.scope.facets =
         { refinePane: new Facet(this.$facetTypes.REFINE_PANE, this.i18n.translations.REFINE_SEARCH, this.scope.config.refinePane.enabled) }

      this.$rootScope.$on("apiSuccess", this.markLoadedFacetGroupAsLoaded)
      this.$rootScope.$on("apiCancel", this.markLoadedFacetGroupAsLoaded)
      this.$rootScope.$on("apiError", this.markLoadedFacetGroupAsLoaded)

      if (this.scope.advFacetsEnabled) {
         _.map(this.scope.config.facets.facetsList, (facet: any) => {
            return this.scope.facets[facet.name] = new Facet(facet.name, this.i18n.translate(facet.label), true)
         })
      }

      _.map(this.scope.config.facets.allFacets, (facet: any) => {
         return this.scope.facets[facet.name] = new Facet(facet.name, this.i18n.translate(facet.label), true)
      })

      // this is used to create the refinePane checkbox values, based on current config
      this.scope.facets.refinePane.config = {
         add_results_beyond_catalog: new FacetDetails(this.$facetTypes.REFINE_PANE, 'add_results_beyond_catalog', this.i18n.translations.ADD_RESULTS_BEYOND_COLLECTION),
         full_text_online: new FacetDetails(this.$facetTypes.REFINE_PANE, 'full_text_online', this.i18n.translations.FULL_TEXT_ONLINE),
         include_matches_full_text_override: new FacetDetails(this.$facetTypes.REFINE_PANE, 'include_matches_full_text_override', this.i18n.translations.INCLUDE_MATCHES_IN_FULL_TEXT),
         limit_to_scholarly: new FacetDetails(this.$facetTypes.REFINE_PANE, 'limit_to_scholarly', this.i18n.translations.SCHOLARLY_PEER_REVIEW),
         items_in_catalog: new FacetDetails(this.$facetTypes.REFINE_PANE, 'items_in_catalog', this.i18n.translations.LIBRARY_CATALOG),
         items_at_my_institution: new FacetDetails(this.$facetTypes.REFINE_PANE, 'items_at_my_institution', this.i18n.translations.ITEMS_AT_MY_INSTITUTION),
         open_access: new FacetDetails(this.$facetTypes.REFINE_PANE, 'open_access', this.i18n.translations.OPEN_ACCESS_FILTER),
         limit_to_peer_reviewed: new FacetDetails(this.$facetTypes.REFINE_PANE, 'limit_to_peer_reviewed', this.i18n.translations.PEER_REVIEW),
         physical_books_only: new FacetDetails(this.$facetTypes.REFINE_PANE, 'physical_books_only', this.i18n.translations.PHYSICAL_BOOKS_LIBRARY_CATALOG),
         ebooks_only: new FacetDetails(this.$facetTypes.REFINE_PANE, 'ebooks_only', this.i18n.translations.EBOOK_FULL_TEXT_ONLINE)
      }

      this.scope.newRecordsDaysFacet = { 7: 7, 30: 30, 90: 90 }


      this.localeSort = this.$filter('localeSort')

      hooksService.setHooks(this, 'AdvancedSearchService', ['clearDate', 'clearSearchScope', 'reflectDate'])

      dataService.on('update', (data: any) => {
         // WH TODO there was a  data.facet_values[0]? check here, but that did not work 
         // - apparently it is an object, and coffeescript was smart enough to get a value from the object, but normal JS isn't. So using Object.values instead
         // @ts-ignore
         if ((data.facet != null) && data.facet_values) {
            const facetCounts: any = Object.values(data.facet_values)[0]
            if (!facetCounts.counts || facetCounts.counts.length === 0) { return }
            _.map(this.scope.facets, (facet: any) => {
               if (facet.name === this.$facetTypes.DATABASE_NAME) { return }
               const configFacet = this.scope.config.facets.facetsList.filter((configFacet: any) => configFacet.name === facet.name)
               if (!facet.values.length) { return facet.values = this.getFacetChecklist(facet.name, data, configFacet?.[0]) }
            })
            const callApis = false // do not call apis, this update event indicates already have been called
            return this.syncWithState(callApis)
         }
      })
   }

   markLoadedFacetGroupAsLoaded(evt: any, msg: any) {
      const self = this
      return angular.forEach(msg.types, function (broadcastType: any) {
         let type
         if (broadcastType === self.$broadcastTypes.contentTypes) {
            type = self.$facetTypes.CONTENT_TYPE
         }
         if (broadcastType === self.$broadcastTypes.disciplines) {
            type = self.$facetTypes.DISCIPLINE
         }
         if (broadcastType === self.$broadcastTypes.languages) {
            type = self.$facetTypes.LANGUAGE
         }
         if (broadcastType === self.$broadcastTypes.library) {
            type = self.$facetTypes.LIBRARY
         }
         if (broadcastType === self.$broadcastTypes.databases) {
            type = self.$facetTypes.DATABASE_NAME
         }
         if (self.scope.facets[type]) { return self.scope.facets[type].loaded = true }
      })
   }


   get(field: any, blockName: any) {
      return this.scope.facets[blockName][field]
   }

   getFacetChecklist(facetType: any, data: any, config: any) {
      if (data.facet.toLowerCase() === facetType.toLowerCase()) {
         // @ts-ignore FIXME type
         const retrievedFacets = config.length ? _.filter(Object.values(data.facet_values)[0].counts, (facet: any) => _.contains(config, facet.value)) : Object.values(data.facet_values)[0].counts
         const facets = this.localeSort(_.map(retrievedFacets, (facet: any) => {
            const translatedValue = this.i18n.translate(facet.value)
            return {
               translation: translatedValue,
               value: facet.value,
               applied: false,
               negated: false,
               order: config.length ? _.indexOf(config, facet.value) : translatedValue
            }
         }), 'order')
         // add the 'Any Type' value
         facets.unshift({
            translation: this.i18n.translations.ANY_TYPE,
            value: '',
            applied: true, // select it always on load
            negated: false
         })

         return facets
      } else {
         return []
      }
   }

   getContentTypes() {
      if (!this.scope.facets.contentType.values.length) {
         this.alerts.resetAlert('contentTypesError')
         return this.api.contentTypes()
      }
   }

   getDisciplines() {
      if (!this.scope.facets.discipline.values.length) {
         this.alerts.resetAlert('disciplinesError')
         return this.api.disciplines()
      }
   }

   getLanguages() {
      if (!this.scope.facets.language.values.length) {
         this.alerts.resetAlert('languagesError')
         return this.api.languages()
      }
   }

   getLibraryLocations() {
      if (!this.scope.facets.library.values.length) {
         this.alerts.resetAlert('libraryError')
         return this.api.libraryLocations()
      }
   }

   isDatabaseBlockVisible() {
      const hasDatabase = (list: any) => _.some(list, (f: any) => f.name === this.$facetTypes.DATABASE_NAME)
      if (this.viewState.scopeBuilderMode) {
         return hasDatabase(this.scope.config.facets.allFacets)
      }
      return !!this.scope.advFacetsEnabled && hasDatabase(this.scope.config.facets.facetsList)
   }

   getDatabases() {
      const facet = this.scope.facets[this.$facetTypes.DATABASE_NAME]
      if (!facet || !this.isDatabaseBlockVisible()) { return }
      const ho = this.holdingsOnly()
      if (facet.values.length && facet.loadedWithHo === ho) { return }
      facet.values = []
      facet.loaded = false
      facet.page = 0
      facet.hasMore = false
      facet.allLoaded = false
      facet.sorted = '-count'
      this.alerts.resetAlert('databaseNameError')
      return this.loadDatabaseValues(1, DATABASE_PAGE_SIZE)
   }

   loadMoreDatabases() {
      const facet = this.scope.facets[this.$facetTypes.DATABASE_NAME]
      if (!facet || facet.loading || !facet.hasMore || facet.allLoaded) { return }
      return this.loadDatabaseValues(facet.page + 1, DATABASE_PAGE_SIZE)
   }

   loadAllDatabases() {
      const facet = this.scope.facets[this.$facetTypes.DATABASE_NAME]
      if (!facet || facet.allLoaded || facet.loadingAll) { return }
      facet.loadingAll = true
      return this.loadDatabaseValues(1, DATABASE_LOAD_ALL_COUNT, true)
   }

   holdingsOnly() {
      return this.appState.params.ho !== false && this.appState.params.ho !== 'f'
   }

   loadDatabaseValues(page: number, count: number, all = false) {
      const ho = this.holdingsOnly()
      this.scope.facets[this.$facetTypes.DATABASE_NAME].loading = true
      return this.api.databases({ ho, facet_page: page, facet_count: count })
         .then((response: any) => {
            const facet = this.scope.facets[this.$facetTypes.DATABASE_NAME]
            const counts = (Object.values(response?.data?.facet_values || {})[0] as any)?.counts || []
            const isFirstLoad = !facet.values.length
            this.appendDatabaseValues(facet, counts)
            facet.loadedWithHo = ho
            if (all) {
               facet.allLoaded = true
               facet.hasMore = false
            } else {
               facet.page = page
               facet.hasMore = counts.length === count
            }
            if (isFirstLoad) {
               this.addSelectedDatabasesMissingFromValues(facet)
               this.syncWithState(false)
            }
         })
         .catch(angular.noop)
         .finally(() => {
            const facet = this.scope.facets[this.$facetTypes.DATABASE_NAME]
            facet.loading = false
            if (all) { facet.loadingAll = false }
         })
   }

   appendDatabaseValues(facet: any, counts: any[]) {
      if (!facet.values.length) {
         facet.values.push({ translation: this.i18n.translations.ANY_TYPE, value: '', applied: true, negated: false })
      }
      const existing = _.pluck(facet.values, 'value')
      _.each(counts, (c: any) => {
         if (!_.contains(existing, c.value)) {
            facet.values.push({ translation: c.value, value: c.value, count: c.count, applied: false, negated: false })
         }
      })
      if (facet.sorted === 'value' || facet.sorted === '-value') {
         this.$filter('localeSort')(facet.values, 'value')
         if (facet.sorted === '-value') { facet.values.reverse() }
      }
   }

   addSelectedDatabasesMissingFromValues(facet: any) {
      const selected = this.parseFacetsFromParams(this.appState.params)
         .concat(this.parseFacetsFromParams(this.appState.searchScopeParams || { fvf: [] }))
         .filter((f: any) => f.name === 'DatabaseName')
      _.each(selected, (f: any) => {
         if (!_.find(facet.values, (v: any) => v.value === f.value)) {
            facet.values.splice(1, 0, { translation: f.value, value: f.value, applied: false, negated: false })
         }
      })
   }

   sortFacetType(type: any, method: any) {
      if (!type || (this.scope.facets[type].values.length <= 0)) {
         return
      }

      // this supports flipping the sort order for alphabetic, if it was already sorted on current method, reverse it
      if ((this.scope.facets[type].sorted === 'value') && (method === 'value')) {
         method = '-value'
      } else if ((this.scope.facets[type].sorted === '-value') && (method === '-value')) {
         method = 'value'
      }

      this.scope.facets[type].values = (() => {
         switch (method) {
            case '-count': return this.$filter('orderBy')(this.scope.facets[type].values, "-count")
            case 'value': return this.$filter('localeSort')(this.scope.facets[type].values, 'value')
            case '-value':
               this.$filter('localeSort')(this.scope.facets[type].values, 'value')
               return this.scope.facets[type].values.reverse()
            case 'selected': return this.$filter('orderBy')(this.scope.facets[type].values, ['-negated', '-applied'])
            case 'negated': return this.$filter('orderBy')(this.scope.facets[type].values, '-negated')
            case 'applied': return this.$filter('orderBy')(this.scope.facets[type].values, '-applied')
            default: return this.scope.facets[type].values
         }
      })()

      return this.scope.facets[type].sorted = method
   }

   shouldDisplayModifiers(key: any) {
      return ['TitleCombined', 'PublicationTitle', 'Notes'].includes(key) || this.$identifierFields.includes(key)
   }

   getOrAddCustomSearchField(idx = -1) {
      const fields = this.viewState.scopeBuilderMode ? this.scope.scopeBuilderSearchFields : this.scope.searchFields
      if (idx === -1) { // if no index specified, return the first field that has no value, and use its index
         const firstEmpty = (_.find(fields, (field: any) => field.value === ''))
         if (firstEmpty != null) {
            idx = firstEmpty.id
         } else {
            return this.viewState.scopeBuilderMode ? this.addCustomField(this.scope.scopeBuilderSearchFields) : this.addCustomField(this.scope.searchFields) // there are no empty fields, create a new field
         }
      }

      if (fields.length > idx) {
         return fields[idx]
      } else {
         return this.viewState.scopeBuilderMode ? this.addCustomField(this.scope.scopeBuilderSearchFields, idx) : this.addCustomField(this.scope.searchFields, idx) // there are no empty fields, create a new field
      }
   }

   addCustomField(searchFields: any, index: number = -1 , isSearchScope: boolean = false) {
      if (!this.hasMaxCustomRows(isSearchScope)) {
         const highestId = (_.max(searchFields, (s) => s.id)).id
         let customFieldToExtend = {}
         if (index === -1) {
            index = highestId
         } else {
            customFieldToExtend = searchFields[index]
         }
         const newField = {
            ...customFieldToExtend,
            key: isSearchScope ? 'IssnAll' : '', 
            value: '', 
            boolean: isSearchScope ? 'OR' : 'AND', 
            queryModifier: '', 
            minLength: 0, 
            id: 1 + highestId 
         }
         searchFields.splice(index + 1, 0, newField)
         return newField
      }
   }

   removeCustomField(searchFields: any, index: any) {
      return searchFields.splice(index, 1)
   }

   removeFacets(facet: any) {
      const type = this.utilities.lowerCaseFirstChar(facet.facetGroup)
      if (type === 'daterange') {
         const clearAllAdvancedSearch = false
         this.fire('clearDate', clearAllAdvancedSearch)
      } else if (this.scope.facets[type]) {
         // @ts-expect-error TS(2554) FIXME: Expected 5 arguments, but got 4.
         this.selectionsOnChange(facet, type, false, false)
      }
      this.removeFacetFromSelectedSummary(facet)
      return false
   }

   clearSearchScopeFromAdvanced(){
      this.fire('clearDate', true)
      this.fire('clearSearchScope')
   }

   clear(clearAll = true) {
      if (clearAll) {
         this.fire('clearDate', clearAll)
         this.clearSearchScopeFromAdvanced()
      }

      // keep the contentTypes and disciplines values, but clear applied/negated
      for (var type in this.scope.facets) {
         var obj = this.scope.facets[type]
         for (var facet of obj.values) {
            facet.applied = facet.value === ""
            facet.negated = false
            facet.fromSearchScope = false
         }
         // make sure the sort is reset and the counts are updated, do not reset order for refinePane, has been ordered by configs
         if (type === this.$facetTypes.DATABASE_NAME) {
            obj.sorted = '-count'
            const [anyType, rest] = _.partition(obj.values, (v: any) => v.value === '')
            obj.values = anyType.concat(this.$filter('orderBy')(rest, '-count'))
            this.updateFacetsInfo(type)
         } else if (type !== this.$facetTypes.REFINE_PANE) {
            obj.sorted = 'value'
            this.updateFacetsInfo(type)
            this.$filter('localeSort')(this.scope.facets[type].values, 'value')
         } else {
            this.updateFacetsInfo(type)
         }
      }
      // clear facets summary
      this.defaultScope.selectedSummary = []
      this.defaultScope.facets = this.scope.facets

      Object.keys(this.defaultScope).map((key) => (this.scope[key] = angular.copy(this.defaultScope[key])))
   }

   buildSearchFieldsQuery() {
      const searchFields = _.reject(this.scope.searchFields.concat(this.scope.scopeBuilderSearchFields), (field: any) => field ? !field.value : true)
      let insideOrOperator = false

      const lastFieldIndex = searchFields.length - 1
      return (_.map(searchFields, function (field: any, index: any) {
         // replace parentheses with escaped ones, to not affect query
         let booleanOperator
         field.value = field.value.replace(/(?!\\)([\(\)])/g, '\\$1')
         if (field.queryModifier === "AnyWords") {
            // split on space chars, but also on OR values (when you search and go back to advanced search, this avoids creating OR OR OR queries :P)
            // TODO maybe remove other BOOLEANS too? If you want to use them, add a new custom field... (or maybe display a warning/hint)
            field.query = field.value.split(/\sOR\s|\s+/gi).join(' OR ')
         } else if (field.queryModifier === "ExactMatch") {
            // strip of begin and end quotes, and escape the rest to make sure that they are part of the query
            field.query = '"' + field.value.replace(/^"+(.*?)"+$/, "$1").replace(/(?![^\\])?"/g, '\\"') + '"'
         } else if (field.queryModifier === "BeginsWith") {
            // strip of begin and end quotes, and escape the rest to make sure that they are part of the query, then add asterisk
            field.query = '"' + field.value.replace(/^"+(.*?)"+$/, "$1").replace(/(?![^\\])?"/g, '\\"') + '*"'
         } else { // allwords
            field.query = field.value
         }

         let query = field.key ? `(${field.key}:(${field.query}))` : `(${field.query})`

         if (index < lastFieldIndex) { booleanOperator = searchFields[index + 1].boolean } // Handle post operator (first must be omitted)

         if (((booleanOperator !== "OR") || (index === lastFieldIndex)) && insideOrOperator) {
            query = `${query})`
            insideOrOperator = false
         } else if ((booleanOperator === "OR") && (index < lastFieldIndex) && !insideOrOperator) {
            query = `(${query}`
            insideOrOperator = true
         }

         // Handle post operator (first must be omitted)
         if (index < lastFieldIndex) { query += ` ${booleanOperator}` }
         return query
      })).join(" ")
   }

   // remove facet from selectedSummary list
   removeFacetFromSelectedSummary(facet: any) {
      const dateIsFromSearchScope = !!this.scope.searchScopeParams?.rf.find((f: any) => f.includes('PublicationDate')) && facet.applied
      const regularIsFromSearchScope = !!this.scope.selectedSummary.find((f: any) => f.value === facet.value)?.fromSearchScope
      
      if(this.scope.searchScope && (dateIsFromSearchScope || regularIsFromSearchScope)){
         this.searchScopeService.clearScopeAsSideEffect(this.scope.newSearchScope || this.scope.searchScope)
         return
      }
      return this.scope.selectedSummary = _.reject(this.scope.selectedSummary, (f: any) => f.value === facet.value)
   }

   findFacet(val: any, type: any) {
      let facet = _.find(this.scope.facets[type].values, (v: any) => v.value === val.value)
      if (!facet && (type === this.$facetTypes.REFINE_PANE)) {
         facet = _.find(this.scope.facets.refinePane.config, (v: any) => v.value === val.value)
      }
      return facet
   }

   // used by internal code
   findAndUpdateFacetAppliedOrNegated(val: any, type: any, applied: any, negated: any, searchScopeApplied: boolean, searchScopeNegated: boolean) {
      let facet
      if (!this.scope.facets[type]) {
         // eslint-disable-next-line no-console
         console.error('Type does not exist: ', type)
         return
      }

      if (!this.scope.facets[type].enabled) {
         if (applied || negated) { // now add it to the facets that are not in adv search
            facet = this.findFacet(val, type)
            facet.applied = applied || searchScopeApplied
            facet.negated = negated || searchScopeNegated
            facet.fromSearchScope = searchScopeApplied || searchScopeNegated
         }
         // return this facet, so we can add it to the selectedSummary later on
         return facet
      }

      if (this.scope.facets[type].values.length === 0) {
         // cannot tell, the collection of facets is not loaded yet
         // eslint-disable-next-line no-console
         console.error('Type does not have values: ', type)
         return
      }

      facet = this.findFacet(val, type)
      if (!facet) {
         console.error(`Could not find ${JSON.stringify(val, null, 2)} for ${type}`)
         return
      }

      facet.facetGroup = type
      facet.applied = applied || searchScopeApplied
      facet.fromSearchScope = searchScopeApplied || searchScopeNegated
      if (negated === true) {
         facet.negated = true
         facet.applied = false
      }
      if (type !== this.$facetTypes.REFINE_PANE) {
         // make sure the anyType is not selected anymore, we don't select anytype with this method
         this.checkAnyType(type, false)
      }
      this.updateFacetsInfo(type)
      return facet
   }

   checkAnyType(type: any, clicked = false) {
      const anyTypeFacet = _.find(this.scope.facets[type].values, (v: any) => v.value === "")
      if (clicked) {
         // in that case, remove all other applied/negated facets and set "" to true (shortcut for Any Type)
         _.each(this.scope.facets[type].values, (v: any) => {
            v.applied = false
            v.negated = false
            this.removeFacetFromSelectedSummary(v)
         })
         if(anyTypeFacet) {
            anyTypeFacet.applied = true // special case 'any' - when yuo click it, it is selected, it only unselects when others are selected
         }
      } else {
         if (anyTypeFacet) {
            return anyTypeFacet.applied = false
         }
      }
   }

   // used by checkBox selector. Since it is an onChange (checkbox) toggle, we flip the value with what comes in here
   selectionsOnChange(val: any, type: any, applied: any, negated: any, $event: any) {
      // if label is disabled dont update the state
      if (val.disabled) {
         return
      }
      // Fix strange behavior: facet was being clicked twice every time checkmark was clicked
      if ($event?.target?.className === 'checkmark') {
         $event.preventDefault()
      }
      const facet = _.find(this.scope.facets[type].values, (v: any) => v.value === val.value)

      if (!facet) {
         // this method is called but the facets are not ready yet, return
         // eslint-disable-next-line no-console
         console.error('facet is undefined: ', type, val)
         return
      }

      if(this.scope.searchScope && facet.fromSearchScope){
         this.searchScopeService.clearScopeAsSideEffect(this.scope.newSearchScope || this.scope.searchScope)
         return
      }

      // .applied == true marks that the facet is selected (like in refine code)
      if ((applied === null) || (applied === false)) {
         facet.applied = false
      } else if (applied === true) {
         facet.applied = !facet.applied // toggle with current value
         if (facet.facetType === this.$facetTypes.NEW_RECORDS) { this.excludeOtherNewRecords(facet) }
      }

      // if negated is set, and it is true, then also set applied to false
      if ((negated === null) || (negated === false)) {
         facet.negated = false
      } else if (negated === true) {
         facet.negated = !facet.negated // toggle with current value
         facet.applied = false
      }

      // only do this if it's not any type and if applied or negated
      if ((val.value !== "") && (facet.negated || facet.applied)) {
         const name = type === this.$facetTypes.REFINE_PANE ? facet.value : this.utilities.titleCase(type)
         const rawValue = type === this.$facetTypes.REFINE_PANE ? 'f' : facet.value
         this.addFacetToSummaryIfAppliedOrNegated(facet, { name, value: rawValue })
      } else {
         this.removeFacetFromSelectedSummary(facet)
      }

      // if val.value is "" then it means 'Any Type' is selected, this is a special case, so it will be handled differently in following code
      this.checkAnyType(type, val.value === "")

      const selectedFacetsCount = this.updateFacetsInfo(type)

      // a bit ugly, but if a user deselects all selected facets, the any type facet should be selected again
      if (!selectedFacetsCount && (type !== this.$facetTypes.REFINE_PANE)) {
         this.checkAnyType(type, true)
         // and we need to update things...
         this.updateFacetsInfo(type)
      } else if (type === this.$facetTypes.REFINE_PANE) {
         this.handlePhysicalAndEbook()
      }
      // make sure the facetGroup is set properly
      facet.facetGroup = type
      return true
   }

   excludeOtherNewRecords(facet: any) {
      this.scope.facets.newRecords.values.filter((record: any) => record !== facet)
         .map((record: any) => {
            record.applied = false
            return this.removeFacetFromSelectedSummary(record)
         })
   }
   //if vale.value is 'print.books.only' or 'ebooks.only' and one of them it's already selected, the checkbox has to be blocked. Only one can be selected at the time
   handlePhysicalAndEbook() {
      const printBooksFacet = 'physical_books_only'
      const eBooksFacet = 'ebooks_only'
      const printBookFilter = _.find(this.scope.facets.refinePane.values, (v: any) => v.value === printBooksFacet)
      const ebookFilter = _.find(this.scope.facets.refinePane.values, (v: any) => v.value === eBooksFacet)
      if (!printBookFilter || !ebookFilter) {
         // if they're not enabled both, we can ignore the following code
         return
      }

      if ((printBookFilter && printBookFilter.applied) && (ebookFilter && ebookFilter.applied)) {
         // removes the ebookfilter... (TODO should we notify user somehow?)
         ebookFilter.applied = false
         ebookFilter.disabled = true
         // and remove from appstate (note that this does not update URL ...) TODO update URL?
         delete this.appState.params[this.eBooksFacet]
         if(this.scope.searchScopeParams[this.eBooksFacet]){
            this.searchScopeService.clearScopeAsSideEffect(this.scope.newSearchScope || this.scope.searchScope)
         }

      } else if (ebookFilter && ebookFilter.applied && printBookFilter) {
         printBookFilter.disabled = true
         ebookFilter.disabled = false
         printBookFilter.applied = false
         delete this.appState.params[this.printBooksFacet]
         if(this.scope.searchScopeParams[this.printBooksFacet]){
            this.searchScopeService.clearScopeAsSideEffect(this.scope.newSearchScope || this.scope.searchScope)
         }
      } else if (printBookFilter && printBookFilter.applied && ebookFilter) {
         ebookFilter.disabled = true
         printBookFilter.disabled = false
         ebookFilter.applied = false
      } else {
         ebookFilter.disabled = false
         printBookFilter.disabled = false
      }

      // and set tooltips
      if (printBookFilter && ebookFilter) {
         printBookFilter.tooltip = this.i18n.translate(this.i18n.translations.QUICKFILTER_REMOVE_OTHER_X, { facet: this.i18n.translations.EBOOK_FULL_TEXT_ONLINE })
         return ebookFilter.tooltip = this.i18n.translate(this.i18n.translations.QUICKFILTER_REMOVE_OTHER_X, { facet: this.i18n.translations.PHYSICAL_BOOKS_LIBRARY_CATALOG })
      }
   }

   updateFacetsInfo(type: any) {
      const appliedFacets = _.filter(this.scope.facets[type].values, (facet: any) => facet.applied)
      const negatedFacets = _.filter(this.scope.facets[type].values, (facet: any) => facet.negated)
      const anyTypeFacet = _.find(this.scope.facets[type].values, (v: any) => v.value === "")
      this.scope.facets[type].applied = anyTypeFacet && anyTypeFacet.applied ? appliedFacets.length - 1 : appliedFacets.length
      this.scope.facets[type].negated = anyTypeFacet && anyTypeFacet.applied ? negatedFacets.length - 1 : negatedFacets.length
      this.scope.facets[type].selected = this.scope.facets[type].negated + this.scope.facets[type].applied
      this.scope['readableSelected' + this.utilities.titleCase(type)] = this.getSelectedAsString(appliedFacets)

      return this.scope.facets[type].selected > 0 // I don't think we do something with this but ¯\_(ツ)_/¯ at least it provides info if any facet is selected
   }

   getSelectedAsString(arr: any) {
      const activeSelection = _.pick(arr, (v: any, k: any) => v)

      if ((activeSelection.length === 0) || activeSelection[""]) {
         return this.i18n.translations.ANY_TYPE
      } else {
         return _.reduce(_.keys(activeSelection), (rest: any, val: any) => rest + ', ' + val)
      }
   }

   getFacetLabel(name: any, value: any) {
      const f = _.find(this.scope.facetsConfig, (facet: any) => facet.name === name)
      if (f != null) {
         return f.label
      } else if (name === this.$facetTypes.REFINE_PANE) {
         return this.i18n.translations.REFINE_SEARCH
      } else {
         return name
      }
   }

   // returns boolean, true means the include full text matches override is disabled in the whole summon site for this client
   includeMatchesInFullTextOverrideIsAlwaysDisabled() {
      return !this.findFacet({ value: 'include_matches_full_text_override' }, this.$facetTypes.REFINE_PANE).active && !this.scope.includeFullTextMatchesOverrideNonAdvanced
   }

   addFacetToSummaryIfAppliedOrNegated(summaryFacet: any, originalFacet: any) {
      if (summaryFacet?.applied || summaryFacet?.negated) {
         summaryFacet.name = originalFacet.name
         summaryFacet.fromSearchScope = originalFacet.fromSearchScope || summaryFacet.fromSearchScope
         // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
         summaryFacet.label = summaryFacet.translation || this.getFacetLabel(originalFacet.name)
         summaryFacet.rawValue = ((originalFacet.name === 'AuthorName') || (originalFacet.name === 'Library')) && originalFacet.originalValue ? originalFacet.originalValue : originalFacet.value

         // check if this facet is already in selectedSummary, if so, we don't hae to push it (causing duplicates)
         const existingSummaryFacet = _.find(this.scope.selectedSummary, (f: any) => (f.name === summaryFacet.name) && (f.label === summaryFacet.label))
         if (!existingSummaryFacet) {
            return this.scope.selectedSummary.push(summaryFacet)
         }
      }
   }

   parseFacetsFromParams(params: any, searchScope = false) {
      return _.map(params.fvf, (f: any) => {
         const v = this.utilities.splitOnEscaped(f, ',')
         return {
            name: v[0],
            value: this.utilities.summonUnEscape(v[1]),
            originalValue: v[1],
            applied: v[2] === 'f',
            negated: v[2] === 't',
            fromSearchScope: searchScope
         }
      })
   }

   syncFacetBasedSearchOptions(facets: any[]){
      // sync all facet based search options
      angular.forEach(facets, (facet: any) => {
         let summaryFacet
         if ((facet.name === 'IsFullText') && (facet.value === 'true') && facet.applied) {
            summaryFacet = this.findAndUpdateFacetAppliedOrNegated({ value: 'full_text_online' }, this.$facetTypes.REFINE_PANE, true, false, facet.fromSearchScope, false)
         } else if ((facet.name === 'IsScholarly') && (facet.value === 'true') && facet.applied) {
            summaryFacet = this.findAndUpdateFacetAppliedOrNegated({ value: 'limit_to_scholarly' }, this.$facetTypes.REFINE_PANE, true, false, facet.fromSearchScope, false)
         } else if ((facet.name === 'IsPeerReviewed') && (facet.value === 'true') && facet.applied) {
            summaryFacet = this.findAndUpdateFacetAppliedOrNegated({ value: 'limit_to_peer_reviewed' }, this.$facetTypes.REFINE_PANE, true, false, facet.fromSearchScope, false)
         } else if ((facet.name === 'IsOpenAccess') && (facet.value === 'true') && facet.applied) {
            summaryFacet = this.findAndUpdateFacetAppliedOrNegated({ value: 'open_access' }, this.$facetTypes.REFINE_PANE, true, false, facet.fromSearchScope, false)
         } else if ((facet.name === 'SourceType') && (facet.value === 'Library Catalog') && facet.applied) {
            summaryFacet = this.findAndUpdateFacetAppliedOrNegated({ value: 'items_in_catalog' }, this.$facetTypes.REFINE_PANE, true, false, facet.fromSearchScope, false)
         } else if ((facet.applied || facet.negated) && this.belongsToAnEnabledFacet(facet)) {
            const type = this.utilities.lowerCaseFirstChar(facet.name)
            summaryFacet = this.findAndUpdateFacetAppliedOrNegated(facet, type, facet.applied, facet.negated, facet.fromSearchScope, false)
         } else {
            summaryFacet = {
               negated: facet.negated,
               applied: facet.applied,
               name: facet.name,
               value: facet.value,
               rawValue: facet.value,
               facetGroup: this.utilities.lowerCaseFirstChar(facet.name),
               translation: this.i18n.translate(facet.value)
            }
         }

         return this.addFacetToSummaryIfAppliedOrNegated(summaryFacet, facet)
      })

      const summaryFacetEBooks = this.findAndUpdateFacetAppliedOrNegated({ value: 'ebooks_only' }, this.$facetTypes.REFINE_PANE, this.appState.params['ebooks.only'] === 'true', false, this.scope.searchScopeParams['ebooks.only'] === 'true', false)
      this.addFacetToSummaryIfAppliedOrNegated(summaryFacetEBooks, { name: 'ebooks_only' })
      const summaryFacetPhysicalBooks = this.findAndUpdateFacetAppliedOrNegated({ value: 'physical_books_only' }, this.$facetTypes.REFINE_PANE, this.appState.params['print.books.only'] === 'true', false, this.scope.searchScopeParams['print.books.only'] === 'true', false)
      this.addFacetToSummaryIfAppliedOrNegated(summaryFacetPhysicalBooks, { name: 'physical_books_only' })
      if (!this.includeMatchesInFullTextOverrideIsAlwaysDisabled()) { // if the override doesn't exist, we don't want to give visibility of the facet to user
         const summaryFacetFullText = this.findAndUpdateFacetAppliedOrNegated({ value: 'include_matches_full_text_override' }, this.$facetTypes.REFINE_PANE, 
            (this.appState.params['include.ft.matches'] === 't') || (this.appState.params['include.ft.matches'] === true), false, (this.scope.searchScopeParams['include.ft.matches'] === 't') || (this.scope.searchScopeParams['include.ft.matches'] === true), false)
         this.addFacetToSummaryIfAppliedOrNegated(summaryFacetFullText, { name: 'include_matches_full_text_override' })
      }
      const summaryFacetHoldingsOnly = this.findAndUpdateFacetAppliedOrNegated({ value: 'add_results_beyond_catalog' }, this.$facetTypes.REFINE_PANE, !this.appState.params.ho, false, !this.scope.searchScopeParams.ho, false)
      this.addFacetToSummaryIfAppliedOrNegated(summaryFacetHoldingsOnly, { name: 'add_results_beyond_catalog' })
      const summaryMyInst = this.findAndUpdateFacetAppliedOrNegated({ value: 'items_at_my_institution' }, this.$facetTypes.REFINE_PANE, this.appState.params.myinst, false, this.scope.searchScopeParams.myinst, false)
      this.addFacetToSummaryIfAppliedOrNegated(summaryMyInst, { name: 'items_at_my_institution' })
   }

   // called from directive
   syncWithState(callApis = true, clear = true) {
      // this might not return immediately (first time it requires API call) so do it again after api call is done (in the .on event on dataService)
      let facets: any = [];
      if (callApis) {
         if (this.scope.facets.contentType) { this.getContentTypes() }
         if (this.scope.facets.discipline) { this.getDisciplines() }
         if (this.scope.facets.language) { this.getLanguages() }
         if (this.scope.facets.library) { this.getLibraryLocations() }
         if (this.scope.facets.databaseName) { this.getDatabases() }
         if (this.scope.facets.refinePane.enabled) { this.setRefinePaneFacets() }
         if (this.scope.facets.newRecords) { this.setNewRecordsFacets() }
      }

      if(clear){
         // clear everything (but datepicker) so the query & facets can be used to pre-fill the fields
         this.clear(false)
         this.scope.selectedSummary = []
         // now sync facets with the available adv search options
         //   fyi publication date is synced via datepicker, not in this method
         if (this.appState.params.fvf.length) {
            facets.push(...this.parseFacetsFromParams(this.appState.params))
         }
         this.parseQueryToAdvancedQuery(this.appState.params.q)
         this.addOrRemoveDateFromSelectedSummary(this.scope.dateSelection.date)
      }
      
      // this is the main fix for issue: CDI-26809: Search Scope changing to All when I search from Advanced Search without changing the value of the search scope 
      this.defaultScope.searchScope = this.searchScopeService.currentSearchScope?.label
      this.scope.searchScopeParams = this.scope.searchScopeParams || angular.copy(this.appState.searchScopeParams)
      this.scope.searchScopeTerms = this.scope.searchScopeParams?.q || ""
      
      if (this.scope.searchScopeParams.fvf.length) {
         facets.push(...this.parseFacetsFromParams(this.scope.searchScopeParams, true))
      }

      this.syncFacetBasedSearchOptions(facets)
      
      this.addNewRecordsFacet()

      this.scope.inUse = true
      this.handlePhysicalAndEbook()
   }

   belongsToAnEnabledFacet(facet: any) {
      const type = this.utilities.lowerCaseFirstChar(facet.name)
      if (type === this.$facetTypes.DATABASE_NAME) { return this.isDatabaseBlockVisible() }
      return !!this.scope.facets[type]
   }

   setRefinePaneFacets() {
      // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
      this.convertConfigListToRefinePane(this.scope.config.refinePane.refineList)
      // create actual values from the config
      const activeSelection = _.filter(this.scope.facets.refinePane.config, (f: any) => f.active)
      const sortedSelection = _.sortBy(activeSelection, (f: any) => f.order)
      return this.scope.facets.refinePane.values = sortedSelection
   }

   convertConfigListToRefinePane(refineList: any, isExclusion: any) {
      return refineList.map((item: any, index: any) => {
         if (!this.scope.facets.refinePane.config[item.name]) {
            this.scope.facets.refinePane.config[item.name] = {}
         }
         // only add translation if it is not in the refinePane.config already
         if (!this.scope.facets.refinePane.config[item.name].translation) {
            this.scope.facets.refinePane.config[item.name].translation = item.label
         }
         this.scope.facets.refinePane.config[item.name].active = true
         return this.scope.facets.refinePane.config[item.name].order = index
      })
   }

   parseTermForQueryModifier(term: any, modifier: any) {
      if (modifier === 'AllWords') {
         return term // don't do parsing lol
      }
      if (modifier === 'AnyWords') {
         return term.replace(/\sOR\s/g, ' ') // remove the ORs
      }
      if (modifier === 'ExactMatch') {
         return term.replace(/^"(.*)"$/, '$1') // remove the ""
      }
      if (modifier === 'BeginsWith') {
         return term.replace(/^"(.*)"$/, '$1').slice(0, -1) // remove the "" and *
      }
   }

   determineQueryModifier(indexName: any, term: any) {
      if (this.shouldDisplayModifiers(indexName)) {
         if (/^"(.*)"$/.test(term)) {
            if (term.indexOf('*') === (term.length - 2)) {
               return 'BeginsWith'
            }
            return 'ExactMatch'
         } else if (term.indexOf('OR') > -1) {
            return 'AnyWords'
         }
      }
      // fallback
      return 'AllWords'
   }

   determineMinLength(modifier: any) {
      if (modifier === 'BeginsWith') { return this.$minLengthForBeginsWithQueries } else { return -1 }
   }

   // knows about escape parentheses \( \) and skips them
   isBalancedWhere(q: any) {
      const stack = []
      if ((q == null) || (q === '')) {
         return 'balanced'
      }

      for (let i = 0; i < q.length; i++) {
         var c = q[i]
         if ((c === '(') && (q[i - 1] !== '\\')) {
            // push position if starting brace, but check for escape char, don't count then
            stack.push(i)
         } else if ((c === ')') && (q[i - 1] !== '\\')) { // check for escape char, don't count then
            var pos = stack.pop()
            if ((pos == null)) {
               return 'left'
            }
         }
      }

      if (stack.length === 0) {
         return 'balanced'
      } else if (stack.length > 0) {
         return 'right'
      }
   }

   isBalanced(q: any) {
      return this.isBalancedWhere(q) === 'balanced'
   }

   // this should clean the right amount of parentheses on either side of input
   // ((foo)) > foo
   // (((foo)) > (foo
   // (foo)) > foo)
   // foo > foo
   cleanParenthesesBalanced(str: any) {
      const b = this.countBalanced(str)
      if (str != null) {
         return str.substring(b.count, str.length - b.count)
      }
   }

   countBalanced(str: any) {
      let c, i
      const b = this.isBalancedWhere(str)
      if ((str == null) || (str === "")) {
         return { count: 0, balanced: b }
      }

      let cnt = 0
      // count parentheses at start of string
      if (b !== 'right') {
         for (i = 0; i < str.length; i++) {
            c = str[i]
            if ((c === '(') && (str[i - 1] !== '\\')) { // check for escape char
               cnt++
            } else {
               break
            }
         }
      } else {
         // count closing parenths at the end, since we're unbalanced on the right
         const iterable = str.split('').reverse()
         for (i = 0; i < iterable.length; i++) {
            c = iterable[i]
            if ((c === ')') && (str[i - 1] !== '\\')) { // check for escape char
               cnt++
            } else {
               break
            }
         }
      }

      return { count: cnt, balanced: b }
   }

   // assumes balanced parentheses, and escape parentheses inside (gr\(ou\)ps)
   splitQueryOnBoolean(q: any) {
      const collect = []
      const stack: any = []
      const groups: any = []
      angular.forEach(q, (c: any, i: any) => {
         if ((c === '(') && (q[i - 1] !== '\\')) {
            collect.push({ idx: i, type: 'parentheses', value: 'open' })
            stack.push(i)
         }
         if ((c === ')') && (q[i - 1] !== '\\')) {
            const match = stack.pop()
            collect.push({ idx: i, type: 'parentheses', value: 'close', matchIdx: match })
            // if starts with a bracket, it's a subgroup, don't add it to the output
            // also skip the group if it is preceded  with  ':(' > this indicates a index search > title:(foobar), split it in index: term parts
            if ((q[match + 1] !== '(') && (q.slice((match - 1), +match + 1 || undefined) !== ':(')) {
               groups.push({ type: 'term', value: q.slice(match + 1, +(i - 1) + 1 || undefined) })
            }
         }

         if (i < (q.length - 5)) { // 'OR'.length
            if (q.substring(i, i + 6) === ') OR (') {
               collect.push({ idx: i + 2, type: 'boolean', value: 'OR', inside: stack.length !== 0 })
               groups.push({ type: 'boolean', value: 'OR' })
            }
         }
         if (i < (q.length - 6)) { // 'AND'.length
            if (q.substring(i, i + 7) === ') AND (') {
               collect.push({ idx: i + 2, type: 'boolean', value: 'AND', inside: stack.length !== 0 })
               groups.push({ type: 'boolean', value: 'AND' })
            }
            if (q.substring(i, i + 7) === ') NOT (') {
               collect.push({ idx: i + 2, type: 'boolean', value: 'NOT', inside: stack.length !== 0 })
               return groups.push({ type: 'boolean', value: 'NOT' })
            }
         }
      })

      return groups
   }

   unescapeParentheses(str: any) {
      return str.replace(/\\([\(\)])/g, '$1')
   }


   parseQueryToAdvancedQueryValues(q: any) {
      if (!!!q) {
         return
      }
      const currentSearchFieldsConfig = this.viewState.scopeBuilderMode ? this.scope.scopeBuilderSearchFieldsConfig : this.scope.config.customSearchFields
      const obj = []
      if ((q.indexOf('(') !== 0) || !this.isBalanced(q)) {
         // won't attempt to parse the query, it doesn't have matching parentheses, just dump it in the first search field
         obj.push(q)
      }

      const splitQuery = this.splitQueryOnBoolean(q)

      angular.forEach(splitQuery, (part: any, i: any) => {
         if (part.type !== 'boolean') {
            const indexSearchMatch = part.value.match(/([^:]+):(\(.+?\))\)?$/)
            if (indexSearchMatch) {
               let needle
               const index = indexSearchMatch[1]
               if ((needle = index, _.pluck(currentSearchFieldsConfig, 'key').includes(needle))) {
                  // clean the parentheses in a 'balanced' way, so count the leading opening ( and remove just as many at the end, so ')' (or other way around)
                  const term = this.unescapeParentheses(this.cleanParenthesesBalanced(indexSearchMatch[2]))
                  const queryModifier = this.determineQueryModifier(index, term)
                  return obj.push(this.parseTermForQueryModifier(term, queryModifier))
               } else {
                  return obj.push(this.unescapeParentheses(this.cleanParenthesesBalanced(part.value)))
               }
            } else {
               return obj.push(this.unescapeParentheses(this.cleanParenthesesBalanced(part.value)))
            }
         }
      })

      return obj
   }

   parseQueryToAdvancedQuery(q: any) {
      if (!!!q) {
         return
      }

      const currentSearchFieldsConfig = this.viewState.scopeBuilderMode ? this.scope.scopeBuilderSearchFieldsConfig : this.scope.config.customSearchFields
      let newField = this.getOrAddCustomSearchField()
      if ((q.indexOf('(') !== 0) || !this.isBalanced(q)) {
         // won't attempt to parse the query, it doesn't have matching parentheses, just dump it in the first search field
         newField.value = q
         return
      }

      const splitQuery = this.splitQueryOnBoolean(q)
      let prevPart: any = null
      // the idea is, check the previous part, if current part == term, and prevPart == term, than just append it to previous value
      return angular.forEach(splitQuery, (part: any, i: any) => {
         if (part.type === 'boolean') {
            // it's a boolean value so create a new field, and set the boolean
            newField = this.getOrAddCustomSearchField()
            newField.boolean = part.value
         } else {
            // check if it is an index search e.g. TitleCombined:(search in title) (it checks for the existence of a string without ':' followed by opening parenth, and a least 1 closing parenth)
            const indexSearchMatch = part.value.match(/([^:]+):(\(.+?\))\)?$/)
            if (indexSearchMatch) {
               let needle
               const index = indexSearchMatch[1]
               // check if this actally a valid index, otherwise put the whole string in the field
               if ((needle = index, _.pluck(currentSearchFieldsConfig, 'key').includes(needle))) {
                  // clean the parentheses in a 'balanced' way, so count the leading opening ( and remove just as many at the end, so ')' (or other way around)
                  const term = this.unescapeParentheses(this.cleanParenthesesBalanced(indexSearchMatch[2]))

                  // determine if it has a query modifier
                  newField.queryModifier = this.determineQueryModifier(index, term)
                  newField.minLength = this.determineMinLength(newField.queryModifier)
                  newField.key = index
                  newField.value = this.parseTermForQueryModifier(term, newField.queryModifier)
               } else {
                  if (prevPart && (prevPart.type === 'term')) {
                     newField.value += ' ' + this.unescapeParentheses(this.cleanParenthesesBalanced(part.value))
                  } else {
                     newField.value = this.unescapeParentheses(this.cleanParenthesesBalanced(part.value))
                  }
               }
            } else {
               if (prevPart && (prevPart.type === 'term')) {
                  newField.value += ' ' + this.unescapeParentheses(this.cleanParenthesesBalanced(part.value))
               } else {
                  newField.value = this.unescapeParentheses(this.cleanParenthesesBalanced(part.value))
               }
            }
         }
         return prevPart = part
      })
   }

   addNewRecordsFacet() {
      const newRecordsFromSearchScope = this.scope.searchScopeParams?.rf.find((f: any) => f.indexOf("NewRecords") > -1)
      const newRecordsFromUser = this.appState.params.rf.find((f: any) => f.indexOf("NewRecords") > -1)
      const newRecordsFacetString = newRecordsFromSearchScope || newRecordsFromUser
      if (newRecordsFacetString) {
         const split = this.utilities.splitOnEscaped(newRecordsFacetString, ',')
         const days = this.utilities.splitOnEscaped(split[1], ':')[0]
         const newRecordsFacet = {
            name: split[0],
            value: split[1],
            applied: true,
            fromSearchScope: !!newRecordsFromSearchScope
         }
         const newRecordsSummaryFacet = {
            name: split[0],
            value: days,
            originalValue: split[1],
            days,
            applied: true,
            negated: false,
            facetGroup: this.$facetTypes.NEW_RECORDS,
            translation: this.i18n.translate(this.i18n.translations.LAST_X_DAYS, { x: days }),
            fromSearchScope: newRecordsFacet.fromSearchScope
         }

         if (this.scope.facets.newRecords) {
            this.scope.facets.newRecords.values.filter((value: any) => value.days === parseInt(days))
               .map((newRecord: any) => { 
                  newRecord.applied = true
                  newRecord.fromSearchScope = newRecordsFacet.fromSearchScope
                  return newRecord 
               })

            // since only one value can be selected, num of applied newRecords is set to 1 (for badges)
            this.scope.facets.newRecords.applied = 1
         }

         return this.addFacetToSummaryIfAppliedOrNegated(newRecordsSummaryFacet, newRecordsFacet)
      }
   }

   setNewRecordsFacets() {
      if (!this.scope.facets.newRecords.values.length) {
         return (() => {
            const result = []
            for (var day in this.scope.newRecordsDaysFacet) {
               var record = new FacetDetails(this.$facetTypes.NEW_RECORDS, day, this.i18n.translate(this.i18n.translations.LAST_X_DAYS, { x: day }))
               record.active = true
               record.days = parseInt(day)
               record.orderBy = 'days'
               result.push(this.scope.facets.newRecords.values.push(record))
            }
            return result
         })()
      }
   }

   addOrRemoveDateFromSelectedSummary(selection: any) {
      this.removeFacetFromSelectedSummary({ value: 'date' })
      if (selection.start) {
         const summaryFacet = {
            applied: true,
            negated: false,
            facetGroup: 'daterange',
            name: this.createDateRangeValue(selection),
            translation: this.createDateRangeValue(selection),
            value: 'date', // use generic value to simplify removal
            label: this.createDateRangeValue(selection)
         }
         return this.scope.selectedSummary.push(summaryFacet)
      }
   }

   createDateRangeValue(selection: any) {
      const preset = selection.selectedYears
      if (preset) { return this.i18n.translations['DATE_PRESET_' + preset + 'Y'] } else { return this.i18n.translations.CUSTOM_DATES }
   }

   setDateSelection(selection: any) {
      this.scope.dateSelection.date = {
         start: selection.start,
         end: selection.end,
         selectedYears: selection.selectedYears
      }
      this.datepickerService.datepicker.search.date.start = selection.start
      this.datepickerService.datepicker.search.date.end = selection.end
      this.addOrRemoveDateFromSelectedSummary(selection)
   }

   toggleOrExcludeValue(facet: any) {
      let tOrF = ''
      if (facet.negated) {
         tOrF = 't'
      }
      if (facet.applied) {
         tOrF = 'f'
      }
      return tOrF
   }

   submit() {
      this.scope.hasSearched = true
      this.scope.inUse = false
      const pubDate = this.datepickerService.datepicker.search

      this.datepickerService.datepicker.clean()

      const setState = () => {
         this.appState.resetParams(false)
         const {
            params
         } = this.appState
         params.q = this.buildSearchFieldsQuery()

         let setDateInQuery = false // set date in query if start date exists or end date exists and is not today, unless that is coming from search scope
         if(!this.scope.searchScopeParams.rf.some((rf: any) => (rf.indexOf('PublicationDate') > -1))){
            if (pubDate.date.start) {
               setDateInQuery = true
            }
            if (pubDate.date.end) {
               const today = new Date()
               if ((pubDate.date.end.getDate() !== today.getDate()) || (pubDate.date.end.getFullYear() !== today.getFullYear()) || (pubDate.date.end.getMonth() !== today.getMonth())) {
                  setDateInQuery = true
               }
            }
         }
         if (setDateInQuery) {
            params.rf.push('PublicationDate,' + (this.utilities.dateToFilterDate(pubDate.date.start) || '*') + ':' + (this.utilities.dateToFilterDate(pubDate.date.end) || '*'))
         }
         const escape = this.utilities.summonEscape
         const self = this
         if (this.scope.facets.contentType?.values) {
            angular.forEach(this.scope.facets.contentType.values, function (val: any, key: any) {
               if (val && (val.value !== "") && !val.fromSearchScope && self.toggleOrExcludeValue(val)) {
                  return params.fvf.push(['ContentType', escape(val.value), self.toggleOrExcludeValue(val)].join(','))
               }
            })
         }
         if (this.scope.facets.discipline?.values) {
            angular.forEach(this.scope.facets.discipline.values, function (val: any, key: any) {
               if (val && (val.value !== "") && !val.fromSearchScope && self.toggleOrExcludeValue(val)) {
                  return params.fvf.push(['Discipline', escape(val.value), self.toggleOrExcludeValue(val)].join(','))
               }
            })
         }
         if (this.scope.facets.language?.values) {
            angular.forEach(this.scope.facets.language.values, function (val: any, key: any) {
               if (val && (val.value !== "") && !val.fromSearchScope && self.toggleOrExcludeValue(val)) {
                  return params.fvf.push(['Language', escape(val.value), self.toggleOrExcludeValue(val)].join(','))
               }
            })
         }
         if (this.scope.facets.library?.values) {
            angular.forEach(this.scope.facets.library.values, function (val: any, key: any) {
               if (val && (val.value !== "") && !val.fromSearchScope && self.toggleOrExcludeValue(val)) {
                  return params.fvf.push(['Library', escape(val.value), self.toggleOrExcludeValue(val)].join(','))
               }
            })
         }
         if (this.scope.facets.databaseName?.values) {
            angular.forEach(this.scope.facets.databaseName.values, function (val: any) {
               if (val && (val.value !== "") && !val.fromSearchScope && self.toggleOrExcludeValue(val)) {
                  const value = val.negated ? self.utilities.summonEscape(val.value) : self.utilities.summonEscapeWithParentesis(val.value)
                  params.fvf.push(['DatabaseName', value, self.toggleOrExcludeValue(val)].join(','))
               }
            })
         }
         if (this.refinePaneFacetApplied('full_text_online') && !this.refinePaneFacetAppliedBySearchScope('IsFullText,true,f')) { params.fvf.push('IsFullText,true,f') }
         if (this.refinePaneFacetApplied('limit_to_scholarly') && !this.refinePaneFacetAppliedBySearchScope('IsScholarly,true,f')) { params.fvf.push('IsScholarly,true,f') }
         if (this.refinePaneFacetApplied('limit_to_peer_reviewed') && !this.refinePaneFacetAppliedBySearchScope('IsPeerReviewed,true,f')) { params.fvf.push('IsPeerReviewed,true,f') }
         if (this.refinePaneFacetApplied('open_access') && !this.refinePaneFacetAppliedBySearchScope('IsOpenAccess,true,f')) { params.fvf.push('IsOpenAccess,true,f') }
         if (this.refinePaneFacetApplied('items_in_catalog') && !this.refinePaneFacetAppliedBySearchScope('SourceType,Library Catalog,f')) { params.fvf.push('SourceType,Library Catalog,f') }

         // add all non-adv facets (that are not removed) too
         angular.forEach(this.scope.selectedSummary, (facet: any) => {
            if (!this.facetHasItsOwnParam(facet) && !facet.fromSearchScope) {
               const includeType = facet.applied ? 'f' : 't'
               const paramsString = `${facet.name},${facet.rawValue},${includeType}`
               const paramsStringEncoded = `${facet.name},${escape(facet.rawValue)},${includeType}`
               if (!_.includes(params.fvf, paramsString) && !_.includes(params.fvf, paramsStringEncoded) && !this.refinePaneFacetApplied(facet.value)) {
                  return params.fvf.push(paramsString)
               }
            }
         })

         // if we are adding results beyond holdings, holdings only (ho) is false
         params.ho = !(this.refinePaneFacetApplied('add_results_beyond_catalog') || this.isAbsentFacetApplied('add_results_beyond_catalog')) && this.scope.searchScopeParams.ho

         if (this.includeMatchesInFullTextOverrideIsAlwaysDisabled()) {
            params['include.ft.matches'] = this.scope.includeFullTextMatchesDefault
         } else {
            params['include.ft.matches'] = (this.refinePaneFacetApplied('include_matches_full_text_override') && ![true, 't'].includes(this.scope.searchScopeParams['include.ft.matches']))|| this.isAbsentFacetApplied('include_matches_full_text_override')
         }
         if ((this.refinePaneFacetApplied('ebooks_only') && !(this.scope.searchScopeParams['ebooks.only'] === 'true')) || this.isAbsentFacetApplied('ebooks_only')) {
            params['ebooks.only'] = 'true'
         } else if ((this.refinePaneFacetApplied('physical_books_only')  && !(this.scope.searchScopeParams['print.books.only'] === 'true'))|| this.isAbsentFacetApplied('physical_books_only')) { // the 'else' statement is because both cannot be apllied at the same time 
            params['print.books.only'] = 'true'
         }
         if (((this.refinePaneFacetApplied('items_at_my_institution') && !this.scope.searchScopeParams['myinst']) || this.isAbsentFacetApplied('items_at_my_institution')) && this.scope.config.refinePane.intstitutionName) {
            params['myinst'] = `${this.scope.config.refinePane.intstitutionName}`
         }
         const newRecordsFacet = _.find(this.scope.selectedSummary, (v: any) => v.name === 'NewRecords')
         if (newRecordsFacet?.applied && !this.scope.searchScopeParams.rf.some((f: any) => (f.indexOf("NewRecords") > -1))) {
            const {
               days
            } = newRecordsFacet
            params.rf.push(`NewRecords,${days}:*`)
         }

         params.searchscope = this.scope.newSearchScope || this.scope.searchScope

         this.events.publish("actions", "advanced_search:query", { params })
         return this.events.gaPush('search', 'advanced', params.q)
      }
      return this.appState.applyStateWithSnapShot(setState)
   }

   // some facets have their own param names and do not use fvf param
   facetHasItsOwnParam(facet: any) {
      return (facet.name === 'add_results_beyond_catalog') || (facet.name === 'include_matches_full_text_override') || (facet.facetGroup === 'daterange') || (facet.name === 'physical_books_only') || (facet.name === 'ebooks_only') || (facet.name === 'items_at_my_institution') || (facet.facetGroup === this.$facetTypes.NEW_RECORDS) || (facet.facetGroup === this.$facetTypes.DATABASE_NAME && this.isDatabaseBlockVisible())
   }

   hasMaxCustomRows(isSearchScope: boolean = false) {
      if (isSearchScope) {
         return this.scope.scopeBuilderSearchFields.length >= this.scope.config.maxSearchScopeFields
      }
      return this.scope.searchFields.length >= this.scope.config.maxCustomFields
   }

   isAbsentFacetApplied(value: any) {
      const facet = _.find(this.scope.selectedSummary, (v: any) => v.value === value)
      if (facet) {
         return facet.applied
      } else {
         return false
      }
   }

   isFacetApplied(type: any, value: any) {
      const facet = _.find(this.scope.facets[type].values, (v: any) => v.value === value)
      if (facet) {
         return facet.applied
      } else {
         // throw error?
         return null
      }
   }

   isFacetNegated(type: any, value: any) {
      const facet = _.find(this.scope.facets[type].values, (v: any) => v.value === value)
      if (facet) {
         return facet.negated
      } else {
         // throw error?
         return null
      }
   }

   refinePaneFacetApplied(value: any) {
      return this.isFacetApplied(this.$facetTypes.REFINE_PANE, value)
   }

   refinePaneFacetAppliedBySearchScope(value: string) {
      return this.appState.searchScopeParams.fvf.includes(value);
   }

   reflectSearchScopeDate(){
      this.fire('reflectDate', this.scope.searchScopeParams)
   }

   resetSearchscope(){
      this.updateSearchScope(this.searchScopeService.currentSearchScope || this.searchScopeService.getDefaultScope())
   }

   removeNewRecordsAppliedBySearchScope() {
      let appliedSetFromTrueToFalse = false
      this.scope.facets.newRecords.values.filter((record: any) => record.fromSearchScope)
         .map((record: any) => {
            appliedSetFromTrueToFalse = appliedSetFromTrueToFalse || record.applied
            record.applied = false
         })
      if(appliedSetFromTrueToFalse) this.scope.facets.newRecords.applied = 0
   }

   removeSearchScopeFacets(){
      this.scope.selectedSummary = [...this.scope.selectedSummary.filter((facet: any) => !facet.fromSearchScope)]
      const facets = []
      if (this.scope.searchScopeParams?.fvf.length) {
         facets.push(...this.parseFacetsFromParams(this.scope.searchScopeParams, true))
      }

      // sync all facet based search options
      angular.forEach(facets, (facet: any) => {
         if (facet.name === 'IsFullText') {
            this.findAndUpdateFacetAppliedOrNegated({ value: 'full_text_online' }, this.$facetTypes.REFINE_PANE, false, false, false, false)
         } else if (facet.name === 'IsScholarly') {
            this.findAndUpdateFacetAppliedOrNegated({ value: 'limit_to_scholarly' }, this.$facetTypes.REFINE_PANE, false, false, false, false)
         } else if (facet.name === 'IsPeerReviewed') {
            this.findAndUpdateFacetAppliedOrNegated({ value: 'limit_to_peer_reviewed' }, this.$facetTypes.REFINE_PANE, false, false, false, false)
         } else if (facet.name === 'IsOpenAccess') {
            this.findAndUpdateFacetAppliedOrNegated({ value: 'open_access' }, this.$facetTypes.REFINE_PANE, false, false, false, false)
         } else if (facet.name === 'SourceType') {
            this.findAndUpdateFacetAppliedOrNegated({ value: 'items_in_catalog' }, this.$facetTypes.REFINE_PANE, false, false, false, false)
         } else if (this.belongsToAnEnabledFacet(facet)) {
            const type = this.utilities.lowerCaseFirstChar(facet.name)
            this.findAndUpdateFacetAppliedOrNegated(facet, type, false, false, false, false)
         } 
      })

      this.findAndUpdateFacetAppliedOrNegated({ value: 'ebooks_only' }, this.$facetTypes.REFINE_PANE, this.appState.params['ebooks.only'] === 'true', false, false, false)
      this.findAndUpdateFacetAppliedOrNegated({ value: 'physical_books_only' }, this.$facetTypes.REFINE_PANE, this.appState.params['print.books.only'] === 'true', false, false, false)
      if (!this.includeMatchesInFullTextOverrideIsAlwaysDisabled()) { // if the override doesn't exist, we don't want to give visibility of the facet to user
         this.findAndUpdateFacetAppliedOrNegated({ value: 'include_matches_full_text_override' }, this.$facetTypes.REFINE_PANE, 
            (this.appState.params['include.ft.matches'] === 't') || (this.appState.params['include.ft.matches'] === true), false, false, false)
      }
      this.findAndUpdateFacetAppliedOrNegated({ value: 'add_results_beyond_catalog' }, this.$facetTypes.REFINE_PANE, !this.appState.params.ho, false, false, false)
      this.findAndUpdateFacetAppliedOrNegated({ value: 'items_at_my_institution' }, this.$facetTypes.REFINE_PANE, this.appState.params.myinst, false, false, false)
      this.removeNewRecordsAppliedBySearchScope()
   }

   updateSearchScope(scope: SearchScope) {
      this.removeSearchScopeFacets()
      this.appState.parseSearchScopeFromUrlParams(scope.query, this.scope.searchScopeParams)
      this.scope.newSearchScope = scope.label
      if (this.scope.searchScopeParams && (!this.scope.searchScopeParams.rf || this.scope.searchScopeParams.rf.length === 0)) {//only updates if search scope publication dates are empty
         this.scope.searchScopeParams.rf = this.appState.params.rf
      }
      this.reflectSearchScopeDate()
      this.syncWithState(false, false)
   }
}

AdvancedSearchService.$inject = ['$rootScope', 'appStateService', 'utilitiesService', '$filter',
   'eventService', 'datepickerService', 'apiService', 'alertService', 'translationService',
   'dataService', 'configService', '$booleanValues', '$identifierFields', '$minLengthForBeginsWithQueries',
   'hooksService', '$broadcastTypes', '$facetTypes', 'searchScopeService', 'viewStateService']

angular.module('summonApp.services')
   .service('advancedSearchService', AdvancedSearchService)
